import React from 'react';
import { createPortal } from 'react-dom';
import { X } from 'lucide-react';
import { propsFundoModal } from '../../../src/lib/backdropModal';

// z-index 120: abre por cima do detalhe da negociação (z-100) e da ficha lateral (z-90).
const LARGURAS = { md: 'max-w-md', lg: 'max-w-2xl', xl: 'max-w-4xl' } as const;

interface Props {
  titulo: string;
  subtitulo?: string;
  onClose: () => void;
  rodape?: React.ReactNode;
  largura?: keyof typeof LARGURAS;
  children: React.ReactNode;
}

const ModalBase: React.FC<Props> = ({ titulo, subtitulo, onClose, rodape, largura = 'lg', children }) =>
  createPortal(
    <div
      className="fixed inset-0 z-[120] flex items-start sm:items-center justify-center bg-black/50 backdrop-blur-sm p-2 sm:p-4 overflow-y-auto"
      {...propsFundoModal(onClose)}
    >
      <div
        className={`relative w-full ${LARGURAS[largura]} bg-white dark:bg-slate-900 rounded-2xl shadow-2xl flex flex-col max-h-[95vh]`}
        onClick={e => e.stopPropagation()}
      >
        <div className="flex items-start justify-between gap-3 px-5 py-4 border-b border-gray-100 dark:border-slate-800">
          <div className="min-w-0">
            <h3 className="text-base font-bold text-gray-900 dark:text-white">{titulo}</h3>
            {subtitulo && <p className="text-xs text-gray-500 dark:text-slate-400 mt-0.5">{subtitulo}</p>}
          </div>
          <button
            onClick={onClose}
            className="p-1.5 rounded-lg text-gray-400 hover:text-gray-700 hover:bg-gray-100 dark:hover:bg-slate-800"
            aria-label="Fechar"
          >
            <X size={18} />
          </button>
        </div>
        <div className="flex-1 overflow-y-auto px-5 py-4">{children}</div>
        {rodape && (
          <div className="px-5 py-3 border-t border-gray-100 dark:border-slate-800 flex justify-end gap-2">{rodape}</div>
        )}
      </div>
    </div>,
    document.body,
  );

export default ModalBase;
